// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"LY-z","subtitle":"MY-z","wrapper":"NY-z","leftArrow":"OY-z","rightArrow":"PY-z"};